let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f3idK")).then(() => parcelRequire('eU56m'));